import Box from '@mui/material/Box';
import { useMobile } from 'src/hooks/useMobile';
import { useMobileDrawer } from 'src/hooks/useMobileDrawer';
import { GradientIcon } from '../gradients/GradientIcon';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
export function HeaderHamburgerIcon() {
  const { toggle, isOpen } = useMobileDrawer();
  const isMobile = useMobile();
  return (
    <>
      {isMobile && (
        <Box
          onClick={toggle}
          sx={{
            alignItems: 'center',
            '&:hover': {
              cursor: 'pointer',
            },
            mr: 0.5,
            display: 'flex',
          }}
        >
          <GradientIcon
            IconComponent={isOpen ? MenuOpenRoundedIcon : MenuRoundedIcon}
            gradientColor="primary.horizontalInverse"
            sx={{ width: 42, height: 42 }}
          />
        </Box>
      )}
    </>
  );
}
